const items = [{
  href: 'https://www.linkedin.com/company/brava-energia/',
  icon: 'icon-linkedin'
}, {
  href: 'https://www.youtube.com/@BravaEnergiaSA',
  icon: 'icon-youtube'
}];

export {
  items
}